export class ConnectionLostError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'Connection Lost';
    }
}